"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaOptions = void 0;
exports.schemaOptions = [
    { value: "char(length)", group: "String" },
    { value: "varchar(length)", group: "String" },
    { value: "string", group: "String" },
    { value: "binary(length)", group: "Binary" },
    { value: "varbinary(length)", group: "Binary" },
    { value: "bytes", group: "Binary" },
    { value: "decimal(precision,scale)", group: "Numeric" },
    { value: "dec(precision,scale)", group: "Numeric" },
    { value: "numeric(precision,scale)", group: "Numeric" },
    { value: "tinyint", group: "Numeric" },
    { value: "smallint", group: "Numeric" },
    { value: "integer", group: "Numeric" },
    { value: "bigint", group: "Numeric" },
    { value: "float", group: "Numeric" },
    { value: "double", group: "Numeric" },
    { value: "date", group: "Date and Time" },
    { value: "time(precision)", group: "Date and Time" },
    { value: "timestamp(precision)", group: "Date and Time" },
    { value: "timestamp_ltz(precision)", group: "Date and Time" },
    { value: "array<type>", group: "Compound" },
    { value: "map<key,value>", group: "Compound" },
    { value: "row<fields>", group: "Compound" },
    { value: "boolean", group: "Other" },
    { value: "interval", group: "Other" },
    { value: "multiset", group: "Other" },
];
